import http from '../../config/http-common';

//Usado somente se for realmente necessário algo fora do padrão GeneralCRUD.service.js
const path = "production/lot"

class service {

    selectList(params) {
        return http.list(path + "/selectList", params);
    }

    getLotsByDateProduced(date) {

        let params = new URLSearchParams()
        params.set("producedDate", date)
        return http.list(path + "/selectItemsToProductionByDate", params)
    }
}

export default new service();

